import { NestedNavLink, SidebarNav } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const SettingsNavigation = () => {
  const { t } = useTranslation(["SettingsLayout"], {
    useSuspense: false,
  });

  return (
    <SidebarNav>
      <NestedNavLink
        id="dd_settings_navigation_boards-list-link"
        to={`/duedates/settings/boards`}
        end={false}
      >
        {t("Navigation.Boards")}
      </NestedNavLink>
      <NestedNavLink
        id="dd_settings_navigation_role-permissions-link"
        to={`/duedates/settings/permissions`}
      >
        {t("Navigation.Permissions")}
      </NestedNavLink>
      <NestedNavLink
        id="dd_settings_navigation_system-preferences-link"
        to={`/duedates/settings/SystemPreferences`}
      >
        {t("Navigation.SystemPreferences")}
      </NestedNavLink>
    </SidebarNav>
  );
};
